import axiosInstance from '@/axiosInstance'
import { getApiUrl } from '@/helper'

import { URL_V2 } from '../../constatns'

export const loadCashSummary = async () => {
  return axiosInstance.get(`${getApiUrl()}${URL_V2}/cash-summary`)
}

export const loadSalesSummary = async () => {
  return axiosInstance.get(`${getApiUrl()}${URL_V2}/sales-summary`)
}
